<template>
    <div @click="toggle" class="header__item header__item--action">
        <icon type="more-vertical" size="20"/>

        <ul v-if="isOpen" class="dropdown-menu dropdown-menu--right" @click.stop :aria-expanded="isOpen">
            <li class="dropdown-menu__item">
                <a href="#" @click.prevent class="dropdown-menu__link">Account settings</a>
            </li>
            <li class="dropdown-menu__item">
                <a href="#" @click.prevent class="dropdown-menu__link dropdown-menu__link--danger">Logout</a>
            </li>
        </ul>
    </div>
</template>

<script>
import Icon from '../Global/Icon'
import Toggleable from '../../mixins/toggle'

export default {
    name: 'MobileNavigation',

    mixins: [Toggleable],

    components: {
        Icon
    }
}
</script>
